module.exports = __webpack_public_path__ + "static/media/15-M-Cure 3.8e8af928.jpg";